<mat-progress-spinner
  [color]="color"
  [mode]="'indeterminate'"
  [diameter]="diameter"
  [strokeWidth]="strokeWidth"
>
</mat-progress-spinner>
